import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import isEqual from 'lodash/isEqual';
import useDidUpdateEffect from '@Hooks/useDidUpdateEffect';

const withStructureFilterLifecycle = (Component) => {
  function StructureFilterLifecycleHOC(props) {
    const {
      filter,
      drawing,
      keyifyParams,
      initializeStructureFilter,
      setSelectedAndExpandedFilter,
      unselectFilter,
      setExpandedFilter,
      selectedOptionsNameValueObjectsArray,
    } = props;

    useEffect(() => {
      const expanded = filter.get('expanded');

      initializeStructureFilter(keyifyParams, filter);

      if (drawing && !expanded) {
        setSelectedAndExpandedFilter(keyifyParams);
      }
    }, []);

    useDidUpdateEffect(() => {
      if (!drawing) {
        unselectFilter(keyifyParams);
        return;
      }

      if (drawing.fromBreadCrumb) {
        setExpandedFilter(keyifyParams);
      } else {
        setSelectedAndExpandedFilter(keyifyParams);
      }
    }, [drawing]);

    useDidUpdateEffect(
      ([prevSelectedOptionsNameValueObjectsArray]) => {
        if (!drawing) {
          return;
        }

        if (!prevSelectedOptionsNameValueObjectsArray) {
          return;
        }

        if (prevSelectedOptionsNameValueObjectsArray === selectedOptionsNameValueObjectsArray) {
          return;
        }

        const { options = [] } = drawing;

        if (!isEqual(options, selectedOptionsNameValueObjectsArray)) {
          setSelectedAndExpandedFilter(keyifyParams);
        }
      },
      [selectedOptionsNameValueObjectsArray, drawing]
    );

    return <Component {...props} />;
  }

  StructureFilterLifecycleHOC.propTypes = {
    filter: PropTypes.instanceOf(Map),
    drawing: PropTypes.object,
    initializeStructureFilter: PropTypes.func,
    keyifyParams: PropTypes.string,
    setSelectedAndExpandedFilter: PropTypes.func,
    unselectFilter: PropTypes.func,
    setExpandedFilter: PropTypes.func,
    selectedOptionsNameValueObjectsArray: PropTypes.array,
  };

  return StructureFilterLifecycleHOC;
};

export default withStructureFilterLifecycle;
